// extracted by mini-css-extract-plugin
export var deleteIcon = "_pl-5";
export var deleteOption = "_pl-3";
export var divider = "_pl-2";
export var downloadIcon = "_pl-4";
export var drawer = "_pl-0";
export var drawerFooter = "_pl-6";
export var drawerOpen = "_pl-1";
export var highlighted = "_pl-7";
export var lighterHighlight = "_pl-8";